import React from "react";
import Dialog from "@material-ui/core/Dialog";
import { Changepass } from "../user/components";

export default function ChangePass(props) {
  return (
    <Dialog open={props.changePass} onClose={props.onChangePass}>
      <div>
        <Changepass {...props} />
      </div>
    </Dialog>
  );
}
